// extracted by mini-css-extract-plugin
export var legendIndicator = "_dk-1";
export var legendRight = "_dk-0";